import { InspectDatabase } from './database.structure';

export default class DatabaseObservableItemActionTypeMethods {
  private db: InspectDatabase;

  constructor(db: InspectDatabase) {
    this.db = db;
  }

  async getObservableItemActionTypes(where?: {
    fieldName: string;
    value: any;
  }) {
    const query = where
      ? this.db.observableItemActionTypes
          .where(where.fieldName)
          .equals(where.value)
      : this.db.observableItemActionTypes;

    return query.toArray().then((observableItemActionTypes) => {
      return Promise.all(
        observableItemActionTypes.map((observableItemActionType) =>
          Promise.all([
            this.db.observableItems.get(
              observableItemActionType.observableItemId,
            ),
            this.db.observableActionTypes.get(
              observableItemActionType.actionTypeId,
            ),
          ]).then(([observableItem, observableActionType]) => {
            return {
              observableItemActionType,
              observableItem,
              observableActionType,
            };
          }),
        ),
      );
    });
  }
}
